export default __webpack_public_path__ + "static/media/9.b9ccc513.png";